import ReconnectingWebSocket from 'reconnecting-websocket'
import pako from 'pako'
import Decimal from 'decimal.js'
import $store from '@/store/index'
import historyProvider from './historyProvider'
import { log } from '@chenfengyuan/vue-qrcode'
// var _subs = []

const url = 'wss://stream.binance.com:9443/ws/'
// const url = 'wss://stream.binance.com:9443/ws/btcusdt@kline_'
const huobiUrl = 'wss://api.huobi.pro/ws'
// const exmoUrl = 'wss://ws.exmoney.com/connection/websocket'
const futuresUrl = 'wss://fstream.binance.com/market/ws/'

const ftxUrl = 'wss://ftx.com/ws/'
const okxUrl = 'wss://ws.okx.com:8443/ws/v5/business'
const bybitUrl = 'wss://stream.bybit.com/v5/public/linear'
const bybitSpotUrl = 'wss://stream.bybit.com/v5/public/spot'
const bitgetUrl = 'wss://ws.bitget.com/v2/ws/public'

const pingInterval = {}

let listener = null

const wsmap = {}

const tv2binanceIntervals = {
  '1': '1m',
  '5': '5m',
  '15': '15m',
  '30': '30m',
  '60': '1h',
  '240': '4h',
  '360': '6h',
  'D': '1d',
  '1D': '1d',
  'W': '1w',
  '1W': '1w',
  'M': '1M',
  '1M': '1M'
}

const tv2huobiIntervals = {
  '1': '1min',
  '5': '5min',
  '15': '15min',
  '30': '30min',
  '60': '60min',
  '240': '4hour',
  '360': '6hour',
  'D': '1day',
  '1D': '1day',
  'W': '1week',
  '1W': '1week',
  'M': '1mon',
  '1M': '1mon'
}

const tv2okxIntervals = {
  '1': 'candle1m',
  '5': 'candle5m',
  '15': 'candle15m',
  '30': 'candle30m',
  '60': 'candle1H',
  '240': 'candle4H',
  '360': 'candle6H',
  'D': 'candle1D',
  '1D': 'candle1D',
  'W': 'candle1W',
  '1W': 'candle1W',
  'M': 'candle1M',
  '1M': 'candle1M'
}

const tv2bybitIntervals = {
  '1': '1',
  '5': '5',
  '15': '15',
  '30': '30',
  '60': '60',
  '120': '120',
  '240': '240',
  '360': '360',
  '720': '720',
  'D': 'D',
  '1D': 'D',
  'W': 'W',
  '1W': 'W',
  'M': 'M',
  '1M': 'M'
}

const tv2bybitSpotIntervals = {
  '1': '1m',
  '5': '5m',
  '15': '15m',
  '30': '30m',
  '60': '1h',
  '120': '2h',
  '240': '4h',
  '360': '6h',
  '720': '12h',
  'D': '1d',
  '1D': '1d',
  'W': '1w',
  '1W': '1w',
  'M': '1M',
  '1M': '1M'
}

const tv2bitgetIntervals = {
  '1': 'candle1m',
  '5': 'candle5m',
  '15': 'candle15m',
  '30': 'candle30m',
  '60': 'candle1H',
  '240': 'candle4H',
  '360': 'candle6Hutc',
  'D': 'candle1Dutc',
  '1D': 'candle1Dutc',
  'W': 'candle1Wutc',
  '1W': 'candle1Wutc',
  'M': 'candle1Mutc',
  '1M': 'candle1Mutc'
}

export default class Stream {
  constructor (owner) {
    this.owner = owner
  }

  subscribeBars (symbolInfo, resolution, updateCb, uid, resetCache) {
    // console.log('TERM subscribeBars:', symbolInfo, resolution, uid)
    // console.log('TERM subscribeBars:', uid)
    let ws = null

    listener = updateCb
    const splitData = symbolInfo.full_name.split(/[:/]/)
    if (splitData.length < 3) {
      return
    }
    const symbol = splitData[1].toLowerCase() + splitData[2].toLowerCase()
    const symb111 = splitData[1] + '_' + splitData[2]
    // console.log('symb111:', symb111)
    // if (ws) {
    //   this.unsubscribeBarsOUR()
    // }
    const exch = splitData[0]
    if (exch === 'BINANCE') {
      ws = new ReconnectingWebSocket(url + symbol + '@kline_' + tv2binanceIntervals[resolution])
    } else if (exch === 'FUTURES') {
      ws = new ReconnectingWebSocket(futuresUrl + symbol + '@kline_' + tv2binanceIntervals[resolution])
    } else if (exch === 'HUOBI') {
      ws = new ReconnectingWebSocket(huobiUrl + 'market.' + symbol + '.kline.' + tv2huobiIntervals[resolution])
      // ws.binaryType = 'arraybuffer'
      // let msg = {
      //   sub: 'market.' + symbol + '.kline.' + tv2huobiIntervals[resolution],
      //   id: 'id1'
      // }
      // ws.send(JSON.stringify(msg))
    } else if (exch === 'EXMO') {
      return
      // ws = new ReconnectingWebSocket(exmoUrl)
    } else if (exch === 'OKX') {
      ws = new ReconnectingWebSocket(okxUrl)
      // ws.send(JSON.stringify({
      //   op: 'subscribe',
      //   args: [{
      //     channel: tv2okxIntervals[resolution],
      //     instId: symbolInfo.name.replace('/', '-')
      //   }]
      // }))
    } else if (exch === 'FTX') {
      ws = new ReconnectingWebSocket(ftxUrl)
      // let symbol = symbolInfo.name
      // if (symbol.includes('-')) {
      //   symbol = symbol.replace('/USD', '')
      // }
      // ws.send(JSON.stringify({
      //   op: 'subscribe',
      //   channel: 'trades',
      //   market: symbol
      // }))
      //
      // pingInterval[uid] = setInterval(() => {
      //   if (ws) {
      //     ws.send('{"op": "ping"}')
      //   }
      // }, 15000)
    } else if (exch === 'BYBIT FUTURES') {
      ws = new ReconnectingWebSocket(bybitUrl)
    } else if (exch === 'BYBIT') {
      ws = new ReconnectingWebSocket(bybitSpotUrl)
    } else if (exch === 'BITGET SPOT' || exch === 'BITGET FUTURES') {
      ws = new ReconnectingWebSocket(bitgetUrl)
    } else {
      console.log('error no such exchange', exch)
      return
    }

    wsmap[uid] = ws
    ws.onopen = () => {
      // console.log('TERM ws connected for:', uid)
      if (exch === 'BYBIT') {
        const wsargs = 'kline.' + tv2bybitIntervals[resolution] + '.' + symbolInfo.name.replace('/', '')
        // console.log('wsargs:', wsargs)
        ws.send(JSON.stringify({
          op: 'subscribe',
          args: [wsargs]
        }))
      } else if (exch === 'BYBIT FUTURES') {
        const wsargs = 'kline.' + tv2bybitIntervals[resolution] + '.' + symbolInfo.name.replace('/', '')
        // console.log('wsargs:', wsargs)
        ws.send(JSON.stringify({
          op: 'subscribe',
          args: [wsargs]
        }))
      } else if (exch === 'OKX') {
        ws.send(JSON.stringify({
          op: 'subscribe',
          args: [{
            channel: tv2okxIntervals[resolution],
            instId: symbolInfo.name.replace('/', '-').replace('-PERP-USDT', '-USDT-SWAP')
          }]
        }))
      } else if (exch === 'BITGET SPOT') {
        ws.send(JSON.stringify({
          op: 'subscribe',
          args: [{
            instType: 'SPOT',
            channel: tv2bitgetIntervals[resolution],
            instId: symbolInfo.name.replace('/', '')
          }]
        }))
        pingInterval[uid] = setInterval(() => {
          if (ws) {
            ws.send('ping')
          }
        }, 60000)
      } else if (exch === 'BITGET FUTURES') {
        ws.send(JSON.stringify({
          op: 'subscribe',
          args: [{
            instType: 'USDT-FUTURES',
            channel: tv2bitgetIntervals[resolution],
            instId: symbolInfo.name.replace('/', '')
          }]
        }))
        pingInterval[uid] = setInterval(() => {
          if (ws) {
            ws.send('ping')
          }
        }, 60000)
      } else if (exch === 'FTX') {
        let symbol = symbolInfo.name
        if (symbol.includes('-')) {
          symbol = symbol.replace('/USD', '')
        }
        ws.send(JSON.stringify({
          op: 'subscribe',
          channel: 'trades',
          market: symbol
        }))

        pingInterval[uid] = setInterval(() => {
          if (ws) {
            ws.send('{"op": "ping"}')
          }
        }, 15000)
      } else if (exch === 'HUOBI') {
        ws.binaryType = 'arraybuffer'
        const msg = {
          sub: 'market.' + symbol + '.kline.' + tv2huobiIntervals[resolution],
          id: 'id1'
        }
        ws.send(JSON.stringify(msg))
      }

      // let msg1 = '{"method":"subscribe","params":{"channel":"BTC_USD_15"},"uid":"1"}'
      // ws.send(msg1)
      // console.log('ws last bar:', historyProvider.lastBar)
    }

    ws.onerror = error => {
      console.log('WebSocket error:', error)
    }

    ws.onclose = () => {
      // console.log('TERM ws closed:', uid)
    }

    ws.onmessage = e => {
      // console.log('ws data:', JSON.stringify(e.data))
      let bar = {}
      if (exch === 'BINANCE' || exch === 'FUTURES') {
        const binbar = JSON.parse(e.data)
        // console.log('ws data:', uid)
        // console.log('ws data:', JSON.stringify(binbar))
        if (binbar.k) {
          bar = {
            time: binbar.k.t, // TradingView requires bar time in ms
            low: parseFloat(binbar.k.l),
            high: parseFloat(binbar.k.h),
            open: parseFloat(binbar.k.o),
            close: parseFloat(binbar.k.c),
            volume: parseFloat(binbar.k.v)
          }
        } else {
          return
        }
      } else if (exch === 'HUOBI') {
        // console.log('ws:', e)
        // console.log('ws data:', e.data)
        const text = pako.inflate(e.data, {
          to: 'string'
        })
        const msg = JSON.parse(text)
        if (msg.ping) {
          ws.send(JSON.stringify({
            pong: msg.ping
          }))
          return
        } else if (msg.tick) {
          bar = {
            time: parseInt(msg.tick.id) * 1000,
            low: new Decimal(msg.tick.low).toNumber(),
            high: new Decimal(msg.tick.high).toNumber(),
            open: new Decimal(msg.tick.open).toNumber(),
            close: new Decimal(msg.tick.close).toNumber(),
            volume: new Decimal(msg.tick.vol).toNumber()
          }
        } else {
          return
          // console.log(text)
        }
      } else if (exch === 'EXMO') {
        // console.log('exmo ws data:', e.data)
      } else if (exch === 'BYBIT') {
        const klinedata = JSON.parse(e.data)
        if (!klinedata.data) {
          return
        }
        const kline = klinedata.data[0]
        if (!kline) {
          return
        }
        bar = {
          time: kline.start,
          open: parseFloat(kline.open),
          high: parseFloat(kline.high),
          low: parseFloat(kline.low),
          close: parseFloat(kline.close),
          volume: parseFloat(kline.volume)
        }
      } else if (exch === 'BYBIT FUTURES') {
        const klinedata = JSON.parse(e.data)
        if (!klinedata.data) {
          return
        }
        const kline = klinedata.data[0]
        if (!kline) {
          return
        }
        bar = {
          time: kline.start,
          open: parseFloat(kline.open),
          high: parseFloat(kline.high),
          low: parseFloat(kline.low),
          close: parseFloat(kline.close),
          volume: parseFloat(kline.volume)
        }
      } else if (exch === 'OKX' || exch === 'BITGET SPOT' || exch === 'BITGET FUTURES') {
        // ingnore pong
        if (e.data === 'pong') {
          return
        }
        const klinedata = JSON.parse(e.data)
        // skip subscribe events
        if (klinedata.event) {
          return
        }
        // ingnore snapshot
        if (klinedata.action === 'snapshot') {
          return
        }
        const kline = klinedata.data[0]
        if (!kline) {
          return
        }
        bar = {
          time: parseInt(kline[0]), // TradingView requires bar time in ms
          open: parseFloat(kline[1]),
          high: parseFloat(kline[2]),
          low: parseFloat(kline[3]),
          close: parseFloat(kline[4]),
          volume: parseFloat(kline[5])
        }
      } else if (exch === 'FTX') {
        // console.log('ftx ws data:', JSON.stringify(e.data))
        const tradesUpdate = JSON.parse(e.data)
        if (tradesUpdate.type === 'subscribed' || tradesUpdate.type === 'pong') {
          return
        } else if (tradesUpdate.type === 'error') {
          console.log('FTX error: ', tradesUpdate.msg)
          return
        }
        // let delay = new Date().getTime() - new Date(tradesUpdate.data[0].time).getTime()
        // console.log('tradesUpdate:', delay, tradesUpdate)
        const trade = tradesUpdate.data[0]

        let nextBarTime
        let lastBar1
        if (this.owner === 'T') {
          nextBarTime = historyProvider.lastBarBySymbol[symb111].time + (resolution * 60 * 1000)
          lastBar1 = historyProvider.lastBarBySymbol[symb111]
        } else if (this.owner === 'B') {
          nextBarTime = historyProvider.botLastBar[symb111].time + (resolution * 60 * 1000)
          lastBar1 = historyProvider.botLastBar[symb111]
        } else if (this.owner === 'G') {
          nextBarTime = historyProvider.gridLastBar[symb111].time + (resolution * 60 * 1000)
          lastBar1 = historyProvider.gridLastBar[symb111]
        }
        // console.log('last bar time:', historyProvider.lastBar.time)
        // console.log('nextBarTime:', nextBarTime)
        // console.log('trades:', tradesUpdate.data)
        const tradeTime = new Date(trade.time).getTime()
        // console.log('trade time:', tradeTime)
        if (tradeTime >= nextBarTime) {
          bar = {
            time: nextBarTime,
            open: lastBar1.close,
            high: Math.max(lastBar1.close, trade.price),
            low: Math.min(lastBar1.close, trade.price),
            close: trade.price
          }
          // if ($store.state.trade.symbol === symb111) {
          historyProvider.lastBarBySymbol[symb111] = bar
          // }
          // console.log('new bar created:', bar)
        } else {
          bar = lastBar1
          bar.close = trade.price
          bar.high = Math.max(bar.high, trade.price)
          bar.low = Math.min(bar.low, trade.price)
          // console.log('bar updated:', bar)
        }
        if (tradesUpdate.data.length > 1) {
          tradesUpdate.data.forEach(trade1 => {
            bar.high = Math.max(bar.high, trade1.price)
            bar.low = Math.min(bar.low, trade1.price)
          })
          bar.close = tradesUpdate.data[tradesUpdate.data.length - 1].price
          // console.log('multiple update:', bar)
        }
      }
      // console.log('new history last bar:', historyProvider.lastBar)
      // console.log('tr:', $store.state.trade.symbol, symb111)

      // console.log('bar:', JSON.stringify(bar))
      // console.log('symb111:', symb111)
      // console.log('$store.state.trade.symbol:', $store.state.trade.symbol)
      // console.log('$store.state.bots.symbol:', $store.state.bots.symbol)
      if (this.owner === 'T') {
        if ($store.state.trade.symbol === symb111) {
          $store.state.sys.lastPrice = new Decimal(bar.close).toString()
        }
      } else if (this.owner === 'B') {
        if ($store.state.bots.symbol === symb111) {
          $store.state.bots.lastPrice = new Decimal(bar.close).toString()
        }
      } else if (this.owner === 'G') {
        if ($store.state.grids.symbol === symb111) {
          $store.state.grids.lastPrice = new Decimal(bar.close).toString()
        }
      }
      updateCb(bar)
    }
  }

  unsubscribeBars (uid) {
    // console.log('unsubscribeBars', uid)
    if (wsmap[uid]) {
      wsmap[uid].close()
      wsmap[uid] = null
    }
    if (pingInterval[uid]) {
      clearInterval(pingInterval[uid])
    }
  }
  // unsubscribeBarsOUR: function (uid) {
  //   // console.log('unsubscribeBars', uid)
  //   if (uid) {
  //     // console.log('...ignored')
  //     return
  //   }
  //   if (ws) {
  //     ws.close()
  //     ws = null
  //   }
  //   if (pingInterval) {
  //     clearInterval(pingInterval)
  //   }
  // }
}
